import KT01BaseLayout from 'general/components/BaseLayout/KT01BaseLayout';
import { Route, Routes } from 'react-router-dom';
import RideKycDetailScreen from './screens/RideKycDetailScreen';
import RideKycListScreen from './screens/RideKycListScreen';

function RideKyc() {
  return (
    <KT01BaseLayout isFullScreen>
      <div className="container-fluid px-0">
        <Routes>
          <Route path="" element={<RideKycListScreen />} />
          <Route path=":driverProfileId" element={<RideKycDetailScreen />} />
          <Route path="*" element={<>Đường dẫn không hợp lệ</>} />
        </Routes>
      </div>
    </KT01BaseLayout>
  );
}

export default RideKyc;
